import React from 'react'
import { Outlet } from 'react-router-dom'

const MainViewDetailsPage = () => {
  return (
    <div>
        <Outlet/>
    </div>
  )
}

export default MainViewDetailsPage